import { render } from "./Zalo.vue?vue&type=template&id=778fd4fc&scoped=true"
const script = {}

import "./Zalo.vue?vue&type=style&index=0&id=778fd4fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778fd4fc"]])

export default __exports__